import type { MarketFlowData, MarketFrame } from '../types/market'
import type { MarketDataProvider } from './MarketDataProvider'

export class JsonMarketDataProvider implements MarketDataProvider {
  private data?: MarketFlowData

  constructor(private readonly source: MarketFlowData | string) {}

  async load(): Promise<MarketFlowData> {
    if (this.data) return this.data
    if (typeof this.source === 'string') {
      const response = await fetch(this.source)
      if (!response.ok) throw new Error(`行情数据加载失败：${response.status}`)
      this.data = (await response.json()) as MarketFlowData
    } else {
      this.data = this.source
    }
    this.validate(this.data)
    return this.data
  }

  getFrame(index: number): MarketFrame | undefined {
    return this.data?.frames[index]
  }

  getFrameByTime(time: string): MarketFrame | undefined {
    return this.data?.frames.find((frame) => frame.time === time)
  }

  getFrameCount(): number {
    return this.data?.frames.length ?? 0
  }

  private validate(data: MarketFlowData): void {
    if (!data.date || data.frames.length < 2) throw new Error('行情数据缺少日期或分钟帧')
    const ids = new Set(data.frames[0].sectors.map((sector) => sector.id))
    if (ids.size !== data.frames[0].sectors.length) throw new Error('首帧包含重复板块 ID')
    for (const frame of data.frames) {
      const frameIds = new Set(frame.sectors.map((sector) => sector.id))
      if (frameIds.size !== ids.size || [...ids].some((id) => !frameIds.has(id))) {
        throw new Error(`${frame.time} 的板块 stable ID 集合不一致`)
      }
    }
  }
}
